<template lang="pug">
div(v-if="cadastroFormulario.destinacaoUsoImovel")
  validation-provider(
      rules="required|validaDestinacaoImovel"
      v-slot="{ errors }"
      :name="'Destinação e Uso do Imóvel/Destinação do Imóvel'"
    )
    span(v-model="isValid")

  el-row(:gutter="30" :class="{'erro' : errorMessage.length}")
    app-label(label="Destinação do Imóvel (pode escolher mais de uma opção)." :required="true")
    el-row.checkbox-group(:gutter="30")
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.agricultura" @change="validateAtLeastOne") Agricultura
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.pecuaria" @change="validateAtLeastOne") Pecuária
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.silvicultura" @change="validateAtLeastOne") Silvicultura
      el-col(:span="8" v-if="tipoCadastro && tipoCadastro === 'ONEROSO'")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.recreacao" @change="validateAtLeastOne") Recreação
    el-row.checkbox-group(:gutter="30" v-if="tipoCadastro && tipoCadastro === 'ONEROSO'")
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.educacao" @change="validateAtLeastOne") Educação
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.industria" @change="validateAtLeastOne") Indústria
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.pesquisa" @change="validateAtLeastOne") Pesquisa
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.mineracao" @change="validateAtLeastOne") Mineração
    el-row.checkbox-group(:gutter="30")
      el-col(:span="8" v-if="tipoCadastro && tipoCadastro === 'ONEROSO'")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.manejoFlorestal" @change="validateAtLeastOne") Manejo Florestal
      el-col(:span="8" v-if="tipoCadastro && tipoCadastro === 'ONEROSO'")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.assistencialHospitalar" @change="validateAtLeastOne") Assistencial/Hospitalar
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.servidaoAmbiental" @change="validateAtLeastOne") Servidão Ambiental
      el-col(:span="8")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.sistemasAgroflorestais" @change="validateAtLeastOne") Sistemas Agroflorestais
      el-col(:span="8" v-if="tipoCadastro && tipoCadastro !== 'ONEROSO'")
        el-row.checkbox-group(:gutter="30")
          el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.outro" @change="validateAtLeastOne") Outro
          el-input(v-if="cadastroFormulario.destinacaoUsoImovel.outro" type="text", placeholder="Descrição outro" v-model="cadastroFormulario.destinacaoUsoImovel.descricaoOutro")
    el-col(:span="12" v-if="tipoCadastro && tipoCadastro === 'ONEROSO'")
      el-row.checkbox-group(:gutter="30")
        el-checkbox(type="checked" v-model="cadastroFormulario.destinacaoUsoImovel.outro" @change="validateAtLeastOne") Outro
        el-input(v-if="cadastroFormulario.destinacaoUsoImovel.outro" type="text", placeholder="Descrição outro" v-model="cadastroFormulario.destinacaoUsoImovel.descricaoOutro")
    // Mensagem de erro
  span.erro-message(v-if="errorMessage.length") {{ errorMessage }}

  el-row.labelDiv(:gutter="30")
    validation-provider(rules="required", v-slot="{ errors }" :name="'Destinação e Uso do Imóvel/Possui Reserva Legal'")
      app-label(label="Possuí Reserva Legal?" :required="true")
      el-radio.input(
        v-model="cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal",
        label="SIM",
        :class="{'erro' : errors.length}"
      ) Sim
      el-radio.input(
        v-model="cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal",
        label="NAO",
        :class="{'erro' : errors.length}"
      ) Não
      el-radio.input(
        v-model="cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal",
        label="NAO_SABE",
        :class="{'erro' : errors.length}"
      ) Não sabe responder
  el-row(v-if="cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal === 'SIM'" :gutter="30")
    el-col(:span="12")
      validation-provider(rules="required|areaReservaLegal", v-slot="{ errors }" :name="'Destinação e Uso do Imóvel/Área Reserva Legal'")
        app-label(label="Área:" :required="true")
        el-input(
          data-vv-delay="10",
          v-model="areaLegal",
          name="ÁreaReservaLegal",
          v-mask-decimal.br="4",
          :maxlength="19",
          :class="{'erro' : errors.length}"
        )
          template(slot="append") hectare(s)
        span.help.erro(v-if="errors.length") {{ errors[0] }}

    el-col(:span="12")
      validation-provider(rules="required|percentualAreaReservaLegal", v-slot="{ errors }" :name="'Destinação e Uso do Imóvel/Percentual Área Reserva Legal'")
        app-label(label="Percentual Utilizado:", :required="true")
        el-input(
          data-vv-delay="10",
          v-model="percentualArealegal",
          name="Percentual"
          v-mask-decimal.br="2",
          :maxlength="6",
          :class="{'erro' : errors.length}"
        )
          template(slot="append") %
        span.help.erro(v-if="errors.length") {{ errors[0] }}
  app-divider(label="Informações de Produção")
  el-row.labelDiv(:gutter="30")
    validation-provider(rules="required", v-slot="{ errors }" :name="'Destinação e Uso do Imóvel/possui comprovante de produtividade'")
      app-label(label="Possui comprovante de produtividade?" :required="true")
      el-radio.input(
        v-model="cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante",
        :label="true",
        :class="{'erro' : errors.length}"
      ) Sim
      el-radio.input(
        v-model="cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante",
        :label="false",
        :class="{'erro' : errors.length}"
      ) Não
      span.help.erro(v-if="errors.length") {{ errors[0] }}
  el-row.labelDiv(v-if="cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante" :gutter="30")
    el-col(:span="12")
      validation-provider(rules="required", v-slot="{ errors }" :name="'Destinação e Uso do Imóvel/Tipo de Comprovante'")
        app-label(label="Tipo de comprovante:" :required="true")
        el-select.input-select(
          v-model='cadastroFormulario.destinacaoUsoImovel.produtividade.tipo',
          placeholder='Selecione',
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for='tipo in tiposComprovante',
            :key='tipo.id',
            :label='tipo.nome',
            :value='tipo.codigo',
          )
        span.help.erro(v-if="errors.length") {{ errors[0] }}
    el-col(
      v-if="cadastroFormulario.destinacaoUsoImovel.produtividade.tipo === 'DAP' || cadastroFormulario.destinacaoUsoImovel.produtividade.tipo === 'DRP'"
      :span="12")
      validation-provider(rules="required", v-slot="{ errors }" :name="'Destinação e Uso do Imóvel/Número do comprovante'")
        app-label(:label="getLabel()" :required="true")
        el-input.input(
          v-if="cadastroFormulario.destinacaoUsoImovel.produtividade.tipo === 'DAP'"
          v-model="cadastroFormulario.destinacaoUsoImovel.produtividade.dap"
          :class="{'erro' : errors.length}"
        )
        el-input.input(
          v-if="cadastroFormulario.destinacaoUsoImovel.produtividade.tipo === 'DRP'"
          v-model="cadastroFormulario.destinacaoUsoImovel.produtividade.drp"
          :class="{'erro' : errors.length}"
        )
        span.help.erro(v-if="errors.length") {{ errors[0] }}
  el-row(v-if="cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante" :gutter="30" style="margin-top: 20px")
    el-col(:span="24")
      app-documentos-retificacao-destinacao-uso-imovel(
        :maxSize='20',
        :valid-extensions="extensoes",
        :documentos="documentosProdutividade"
        :tiposDocumentos="[]"
        :observer="this.$refs.validation",
        :isDocumentoImagex="true",
        titulo="Documentação",
        aba="DestinacaoUsoImovel",
        idUploadDocumento="appUploadDocumentosInteressado",
        @addedDoc="handleDocs",
        @removedDoc="removerDocs"
      )
  el-row.div(:gutter="30")
    el-col(:span="8")
      app-label(label="Atividade:" :required="false")
      el-select(
        v-model="tipoAtividade",
        placeholder="Selecione",
        @change="changeTipoAtividade()"
      )
        el-option(
          v-for='tipo in atividades',
          :key='tipo.id',
          :label='tipo.label',
          :value='tipo.codigo',
        )

  app-divider(v-if="tipoAtividade" :label="getLabelProdutividadeTipo()")
  el-form(:model="ruleForm" :rules="rules" ref="ruleForm")
    el-row(v-if="tipoAtividade" :gutter="30" style="padding-top: 20px")
      el-col(:span="8")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Tipo:" :required="true")
          el-form-item(prop="tipoDaAtividade")
            el-select(
              v-model="ruleForm.tipoDaAtividade",
              placeholder="Selecione",
              :class="{'erro' : errors.length}"
            )
              el-option(
                v-for='tipo in listaDoTipo',
                :key='tipo.id',
                :label='tipo.label',
                :value='tipo.codigo',
              )
      el-col(v-if="ruleForm.tipoDaAtividade === 'OUTROS'" :span="8")
          app-label(label="Descrição:" :required="true")
          el-form-item(prop="descricao")
            el-input(
              data-vv-delay="10",
              v-model="ruleForm.descricao",
            )
      el-col(v-if="tipoAtividade === 'SEMOVENTES'" :span="8")
          app-label(label="Número de Cabeças:" :required="true")
          el-form-item(prop="cabecas")
            el-input-number(
              data-vv-delay="10",
              :controls="false"
              v-model="ruleForm.cabecas",
            )
      el-col(v-if="tipoAtividade !== 'EDIFICACOES' && tipoAtividade !== 'SEMOVENTES'" :span="8")
          app-label(label="Área:" :required="true")
          el-form-item(prop="areaDaAtividade")
            el-input(
              data-vv-delay="10",
              v-model="ruleForm.areaDaAtividade",
              v-mask-decimal.br="4",
              :maxlength="19",
            )
              template(slot="append") hectare(s)
      el-col(v-if="tipoAtividade === 'EDIFICACOES'" :span="8")
        app-label(label="Área:" :required="true")
        el-row.flex(:gutter="30")
          el-form-item(prop="areaDaAtividade")
            el-input(
              data-vv-delay="10",
              v-model="ruleForm.areaDaAtividade",
              v-mask-decimal.br="4",
              :maxlength="19",
            )
          el-form-item(prop="unidadeMedida")
            el-select(
              v-model="ruleForm.unidadeMedida"
              placeholder="Unidade de Medida"
            )
              el-option(
                v-for='tipo in medidas',
                :key='tipo.id',
                :label='tipo.label',
                :value='tipo.codigo',
              )
      el-col(v-if="tipoAtividade === 'OUTRAS_ATIVIDADES'" :span="8")
        app-label(label="Observações:" :required="true")
        el-form-item(prop="observacaoDaAtividade")
          el-input(
            v-model="ruleForm.observacaoDaAtividade",
          )
  el-row(v-if="tipoAtividade" :gutter="30" style="padding-top: 20px")
    el-col.row-buttons(:span="12")
      el-button.el-icon-error(round @click="limpaCampos") &nbsp cancelar
    el-col.row-buttons-sucess(:span="12")
      el-button.el-icon-circle-plus(type="success" round @click="submitForm('ruleForm')") &nbsp adicionar

  div.class-divider(v-if="possuiListaAtividades")
    el-col(:span="12")
      p.texto-paragrafo Listagem de Atividades
    el-col(:span="12")
      .row
        p.texto-paragrafo Total da área em uso:
        p &nbsp {{ getAreas }}
  div(v-if="cadastroFormulario.destinacaoUsoImovel.semoventes.length > 0")
    el-collapse(accordion)
      el-collapse-item(title="Semoventes (Animais)" name="1")
        app-table-listagem-atividades(
          :listagem="cadastroFormulario.destinacaoUsoImovel.semoventes",
          tipoCodigoAtividade="SEMOVENTES"
          @deletaItemLista="deletaItemLista"
        )
  div(v-if="cadastroFormulario.destinacaoUsoImovel.edificacoes.length > 0")
    el-collapse(accordion)
      el-collapse-item(title="Edificações" name="2")
        app-table-listagem-atividades(
          :listagem="cadastroFormulario.destinacaoUsoImovel.edificacoes",
          tipoCodigoAtividade="EDIFICACOES"
          @deletaItemLista="deletaItemLista"
        )
  div(v-if="cadastroFormulario.destinacaoUsoImovel.culturasPermanentes.length > 0")
    el-collapse(accordion)
      el-collapse-item(title="Culturas Permanentes" name="3")
        app-table-listagem-atividades(
          :listagem="cadastroFormulario.destinacaoUsoImovel.culturasPermanentes",
          tipoCodigoAtividade="CULTURA_PERMANENTE"
          @deletaItemLista="deletaItemLista"
        )
  div(v-if="cadastroFormulario.destinacaoUsoImovel.culturasTemporarias.length > 0")
    el-collapse(accordion)
      el-collapse-item(title="Culturas Temporarias" name="4")
        app-table-listagem-atividades(
          :listagem="cadastroFormulario.destinacaoUsoImovel.culturasTemporarias",
          tipoCodigoAtividade="CULTURA_TEMPORARIA"
          @deletaItemLista="deletaItemLista"
        )
  div(v-if="cadastroFormulario.destinacaoUsoImovel.outrasAtividades.length > 0")
    el-collapse(accordion)
      el-collapse-item(title="Outras Atividades" name="5")
        app-table-listagem-atividades(
          :listagem="cadastroFormulario.destinacaoUsoImovel.outrasAtividades",
          tipoCodigoAtividade="OUTRAS_ATIVIDADES"
          @deletaItemLista="deletaItemLista"
        )

</template>

<script>
import { TheMask } from 'vue-the-mask'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppDocumentosRetificacaoDestinacaoUsoImovel from '@/screens/central/components/cadastro/AppDocumentosRetificacaoDestinacaoUsoImovel'
import AppLabel from '@/components/AppLabel'
import AppTableListagemAtividades from '@/screens/central/components/cadastro/AppTableListagemAtividades'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default
const tiposAtividades = require('@/utils/tiposAtividades').default
const tipoCulturasTemporarias = require('@/utils/tipoCulturasTemporarias').default
const tipoCulturasPermanentes = require('@/utils/tipoCulturasPermanentes').default
const tipoEdificacoes = require('@/utils/tipoEdificacoes').default
const tipoSemoventes = require('@/utils/tipoSemoventes').default
const tipoOutrasAtividades = require('@/utils/tipoOutrasAtividades').default
const tipoUnidadesMedidas = require('@/utils/tipoUnidadesMedidasEdificacao').default

const validacaoCabecas = (rule, value, callback) => {
  if (value === 0) {
    callback(new Error('O valor inserido no campo deve ser superior a zero.'))
  }
  callback()
}

export default {

  components: {
    AppLabel,
    AppDocumentosRetificacaoDestinacaoUsoImovel,
    AppTableListagemAtividades
  },

  directives: {
    mask: TheMask
  },

  props: ['cadastro', 'observer', 'idProcesso'],

  data () {
    return {
      inputsExtraCadastro,
      documentos: [],
      documentosObrigatorio: [],
      cadastroFormulario: [],
      textoElSelect: 'hectares(s)',
      errorMessage: '',
      extensoes: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      documentosProdutividade: [],
      tiposComprovante: [
        {id: 0, codigo: 'DAP', nome: 'Declaração de Aptidão ao PRONAF – DAP'},
        {id: 1, codigo: 'DRP', nome: 'Diagnóstico Rural Participativo – DRP'},
        {id: 2, codigo: 'OUTROS', nome: 'Outros'}
      ],
      atividades: null,
      tipoAtividade: null,
      tipoDaAtividade: null,
      listaDoTipo: null,
      areaDaAtividade: null,
      observacaoDaAtividade: null,
      medidas: null,
      ruleForm: {
        areaDaAtividade: '',
        tipoDaAtividade: '',
        observacaoDaAtividade: '',
        descricao: '',
        cabecas: '',
        unidadeMedida: ''
      },
      rules: {
        areaDaAtividade: [
          { required: true, message: 'O campo é obrigatório', trigger: 'blur' }
        ],
        unidadeMedida: [
          { required: true, message: 'O campo é obrigatório', trigger: 'change' }
        ],
        tipoDaAtividade: [
          { required: true, message: 'O campo é obrigatório', trigger: 'change' }
        ],
        observacaoDaAtividade: [
          { required: true, message: 'O campo é obrigatório', trigger: 'blur' }
        ],
        descricao: [
          { required: true, message: 'O campo é obrigatório', trigger: 'blur' }
        ],
        cabecas: [
          { required: true, validator: validacaoCabecas, trigger: 'blur' }
        ]
      },
      possuiListaAtividades: false,
      listaSemoventes: null,
      listaEdificacoes: null,
      listaCulturasPermanentes: null,
      listaCulturasTemporarias: null,
      listaOutrasAtividades: null,
      getAreas: null,
      listDocs: null,
      percentualArealegal: 0,
      areaLegal: 0,
      listDocsRemovidos: null,
      isValid: null,
      tipoCadastro: null
    }
  },

  async created () {
    const jsonCadastro = await this.findByIdCadastro(this.idProcesso)
    this.CADASTRO_INICIAL(JSON.parse(jsonCadastro.json))
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    this.atividades = this.findAtividadesByTipoProcesso()
    this.validateAtLeastOne()
    this.medidas = tipoUnidadesMedidas.filter(medida => medida.tipo === 'AREA')
    this.possuiListaAtividades = this.findAnylista()
    this.getAreas = this.getAreasFormatadas()
    this.tipoCadastro = this.tipo.replace(/['"]/g, '')
    this.documentosProdutividade = this.cadastroFormulario?.destinacaoUsoImovel?.produtividade?.documentos
    this.areaLegal = this.formataNumeroToFloatFixed(this.cadastroFormulario?.destinacaoUsoImovel?.areaReservaLegal, true)
    this.percentualArealegal = this.formataNumeroToFloatFixed(this.cadastroFormulario?.destinacaoUsoImovel?.percentualAreaReservalegal, false)
  },

  computed: {
    ...mapGetters({
      cadastroJson: 'retificacao/cadastro',
      versao: 'retificacao/versao',
      tipo: 'retificacao/tipo'
    })
  },

  methods: {
    ...mapActions('retificacao', ['update', 'setIsValidoDestinacaoImovel']),
    ...mapActions({
      findByIdCadastro: 'cadastro/findCadastroById',
      baixarDocumento: 'cadastro/downloadDocumentoCentral',
      salvarCadastroRetificacao: 'cadastroRetificacao/salvarCadastroByIdProcesso',
      deleteDocumentoById: 'documentos/deleteDocumentoById',
      saveRelDocumentoProcessoRetificacao: 'relDocumentoProcessoRetificacao/saveRelDocumentoProcessoRetificacao'
    }),
    ...mapMutations(
      'retificacao', [
        'CADASTRO_INICIAL', 'CHANGE_POSSUI_CAR', 'CHANGE_HA_CONFLITOS', 'UPDATE_CAMPOS_RESERVA_LEGAL',
        'UPDATE_CAMPOS_PRODUTIVIDADE', 'UPDATE_PRODUTIVIDADE_TIPO_AND_DOC'
      ]
    ),

    validateAtLeastOne () {
      if (
        this.cadastroFormulario.destinacaoUsoImovel.agricultura || this.cadastroFormulario.destinacaoUsoImovel.pecuaria ||
        this.cadastroFormulario.destinacaoUsoImovel.silvicultura || this.cadastroFormulario.destinacaoUsoImovel.servidaoAmbiental ||
        this.cadastroFormulario.destinacaoUsoImovel.sistemasAgroflorestais || this.cadastroFormulario.destinacaoUsoImovel.outro ||
        this.cadastroFormulario.destinacaoUsoImovel.recreacao || this.cadastroFormulario.destinacaoUsoImovel.educacao ||
        this.cadastroFormulario.destinacaoUsoImovel.industria || this.cadastroFormulario.destinacaoUsoImovel.pesquisa ||
        this.cadastroFormulario.destinacaoUsoImovel.mineracao || this.cadastroFormulario.destinacaoUsoImovel.manejoFlorestal ||
        this.cadastroFormulario.destinacaoUsoImovel.assistencialHospitalar
      ) {
        this.errorMessage = ''
        this.isValid = true
        this.setIsValidoDestinacaoImovel(true)
      } else {
        this.errorMessage = 'Você deve selecionar pelo menos uma opção.'
        this.isValid = null
        this.setIsValidoDestinacaoImovel(false)
      }
    },

    async handleDocs (dados) {
      const doc = {
        id: null,
        _id: dados.id,
        key: dados.fileKey,
        hash: null,
        nome: dados.fileName,
        tipo: dados.tipoDocumento,
        base64: null,
        caminho: null
      }
      const newDoc = await this.createDocByKey(doc)
      this.documentosProdutividade.push(newDoc)
      this.listDocs = [...this.documentosProdutividade]
      const payload = {
        idDocumento: newDoc.id,
        idProcesso: this.idProcesso
      }
      await this.saveRelDocumentoProcessoRetificacao(payload)
    },

    async removerDocs (doc) {
      const listaDocumentos = this.cadastroFormulario.destinacaoUsoImovel.produtividade.documentosRemovidos
        ? this.cadastroFormulario.destinacaoUsoImovel.produtividade.documentosRemovidos
        : []
      this.listDocsRemovidos = [...listaDocumentos, doc]
      this.listDocs = [...this.documentosProdutividade.filter(documento => doc.id !== documento.id)]
      if (doc?.id) {
        await this.deleteDocumentoById(doc.id)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.fileName)
    },
    async createDocByKey (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/createByKey`,
        data: documento
      })
      return file
    },

    downloadArquivo (arquivo) {
      this.getDownload(arquivo)
    },

    getLabel () {
      // cria variável, para evitar erro no console ao tentar aplicar o valor diretamente no template String
      const tipoProdutividade = this?.cadastroFormulario?.destinacaoUsoImovel?.produtividade?.tipo
      return this.cadastroFormulario ? `Número do ${tipoProdutividade}:` : null
    },

    getLabelProdutividadeTipo () {
      const atividade = tiposAtividades.filter(tipo => tipo.codigo === this.tipoAtividade)
      return atividade[0].label
    },

    findAtividadesByTipoProcesso () {
      if (this.cadastroFormulario.tipo === 'NAO_ONEROSO' || this.cadastroFormulario.tipo === 'ONEROSO') {
        return tiposAtividades
          .filter(tipo =>
            tipo.codigo !== 'MANEJO_FLORESTAL' && tipo.codigo !== 'SILVICULTURA'
          ).sort((a, b) => {
            return a.codigo.localeCompare(b.codigo)
          })
      }
      return tiposAtividades
    },
    changeTipoAtividade () {
      this.ruleForm.tipoDaAtividade = ''
      switch (this.tipoAtividade) {
        case ('CULTURA_PERMANENTE'):
          this.listaDoTipo = tipoCulturasPermanentes
          break
        case ('SEMOVENTES'):
          this.listaDoTipo = tipoSemoventes.filter(tipo => tipo.showTipo)
          break
        case ('OUTRAS_ATIVIDADES'):
          this.listaDoTipo = tipoOutrasAtividades.filter(tipo => tipo.showTipo)
          break
        case ('EDIFICACOES'):
          this.listaDoTipo = tipoEdificacoes.filter(tipo => tipo.showTipo).sort((a, b) => a.label.localeCompare(b.label))
          break
        default:
          this.listaDoTipo = tipoCulturasTemporarias.filter(tipo => tipo.showTipo)
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let numArea = null
          if (this.ruleForm.areaDaAtividade) {
            numArea = parseFloat(this.ruleForm.areaDaAtividade.toString().replace(',', '.'))
          }

          let newObjectCultura = {
            area: numArea,
            descTipo: '',
            descricao: this.ruleForm.descricao,
            tipo: this.ruleForm.tipoDaAtividade
          }
          switch (this.tipoAtividade) {
            case 'SEMOVENTES':
              const newObjectSemoventes = {
                area: this.ruleForm.areaDaAtividade ? this.ruleForm.areaDaAtividade : 0,
                tipo: this.ruleForm.tipoDaAtividade,
                descTipo: tipoSemoventes.filter(item => item.codigo === this.ruleForm.tipoDaAtividade)[0].label,
                numeroCabecas: this.ruleForm.cabecas,
                descricao: this.ruleForm.descricao
              }
              this.cadastroFormulario.destinacaoUsoImovel.semoventes.push(newObjectSemoventes)
              this.listaSemoventes = this.cadastroFormulario.destinacaoUsoImovel.semoventes
              break
            case 'EDIFICACOES':
              const newObjectEdificacoes = {
                area: numArea,
                descTipo: tipoEdificacoes.filter(item => item.codigo === this.ruleForm.tipoDaAtividade)[0].label,
                tipo: this.ruleForm.tipoDaAtividade,
                descricao: this.ruleForm.descricao,
                funcao: null,
                unidadeAreaMedida: this.ruleForm.unidadeMedida,
                descUnidadeArea: tipoUnidadesMedidas.filter(item => item.codigo === this.ruleForm.unidadeMedida)[0].listagem
              }
              this.cadastroFormulario.destinacaoUsoImovel.edificacoes.push(newObjectEdificacoes)
              this.listaEdificacoes = this.cadastroFormulario.destinacaoUsoImovel.edificacoes
              break
            case 'CULTURA_PERMANENTE':
              newObjectCultura.descTipo = tipoCulturasPermanentes.filter(item => item.codigo === this.ruleForm.tipoDaAtividade)[0].label
              this.cadastroFormulario.destinacaoUsoImovel.culturasPermanentes.push(newObjectCultura)
              this.listaCulturasPermanentes = this.cadastroFormulario.destinacaoUsoImovel.culturasPermanentes
              break
            case 'CULTURA_TEMPORARIA':
              newObjectCultura.descTipo = tipoCulturasTemporarias.filter(item => item.codigo === this.ruleForm.tipoDaAtividade)[0].label
              this.cadastroFormulario.destinacaoUsoImovel.culturasTemporarias.push(newObjectCultura)
              this.listaCulturasTemporarias = this.cadastroFormulario.destinacaoUsoImovel.culturasTemporarias
              break
            default:
              const newObjectOutrasAtividades = {
                area: numArea,
                descricao: this.ruleForm.descricao,
                tipo: this.ruleForm.tipoDaAtividade,
                observacoes: this.ruleForm.observacaoDaAtividade
              }
              this.cadastroFormulario.destinacaoUsoImovel.outrasAtividades.push(newObjectOutrasAtividades)
              this.listaOutrasAtividades = this.cadastroFormulario.destinacaoUsoImovel.outrasAtividades
          }
          this.limpaCampos()
          this.getAreas = this.getAreasFormatadas()
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    findAnylista () {
      return this.cadastroFormulario?.destinacaoUsoImovel?.culturasPermanentes.length > 0 ||
        this.cadastroFormulario?.destinacaoUsoImovel?.semoventes.length > 0 ||
        this.cadastroFormulario?.destinacaoUsoImovel?.culturasTemporarias.length > 0 ||
        this.cadastroFormulario?.destinacaoUsoImovel?.edificacoes.length > 0 ||
        this.cadastroFormulario?.destinacaoUsoImovel?.outrasAtividades.length > 0
    },
    limpaCampos () {
      this.tipoAtividade = ''
      this.ruleForm.areaDaAtividade = ''
      this.ruleForm.tipoDaAtividade = ''
      this.ruleForm.observacaoDaAtividade = ''
      this.ruleForm.descricao = ''
      this.ruleForm.cabecas = ''
      this.ruleForm.unidadeMedida = ''
    },

    getAreasFormatadas () {
      const areaCulturasPermanentes = this.getAreasSoma(this.cadastroFormulario?.destinacaoUsoImovel?.culturasPermanentes)
      const areaCulturasTemporarias = this.getAreasSoma(this.cadastroFormulario?.destinacaoUsoImovel?.culturasTemporarias)
      const areOutrasAtividades = this.getAreasSoma(this.cadastroFormulario?.destinacaoUsoImovel?.outrasAtividades)
      return `${(areaCulturasPermanentes + areaCulturasTemporarias + areOutrasAtividades).toString().replace('.', ',')} hectare(s)`
    },

    getAreasSoma (lista) {
      return lista.reduce((total, obj) => {
        let area = obj.area
        // Se for string, substituir vírgula por ponto e converter para número
        if (typeof area === 'string') {
          area = parseFloat(area.replace(',', '.'))
        }
        // Somar a área ao total
        return total + area
      }, 0)
    },

    deletaItemLista (atividade, listagem) {
      switch (atividade) {
        case 'SEMOVENTES':
          this.listaSemoventes = listagem
          break
        case 'EDIFICACOES':
          this.listaEdificacoes = listagem
          break
        case 'CULTURA_PERMANENTE':
          this.listaCulturasPermanentes = listagem
          break
        case 'CULTURA_TEMPORARIA':
          this.listaCulturasTemporarias = listagem
          break
        default:
          this.listaOutrasAtividades = listagem
      }
      this.getAreas = this.getAreasFormatadas()
    },

    formataNumeroToFloatFixed (num, area) {
      let valor = parseFloat(num)
      return area ? valor.toFixed(4) : valor.toFixed(3)
    },

    montarJson () {
      const jsonCadastro = {
        tipo: this.tipo,
        versao: this.versao,
        dados: {
          cadastro: this.cadastroFormulario
        }
      }
      return JSON.stringify(jsonCadastro)
    }

  },
  watch: {
    'cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal' (val) {
      this.update({field: 'destinacaoUsoImovel.possuiReservaLegal', value: val})
      this.UPDATE_CAMPOS_RESERVA_LEGAL(val)
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'areaLegal' (val) {
      this.update({field: 'destinacaoUsoImovel.areaReservaLegal', value: parseFloat(val.toString().replace(',', '.'))})
    },
    'percentualArealegal' (val) {
      this.update({field: 'destinacaoUsoImovel.percentualAreaReservalegal', value: parseFloat(val.toString().replace(',', '.'))})
    },
    'cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante' (val) {
      this.update({field: 'destinacaoUsoImovel.produtividade.possuiComprovante', value: val})
      this.UPDATE_CAMPOS_PRODUTIVIDADE(val)
    },
    'cadastroFormulario.destinacaoUsoImovel.produtividade.tipo' (val) {
      this.update({field: 'destinacaoUsoImovel.produtividade.tipo', value: val})
      this.UPDATE_PRODUTIVIDADE_TIPO_AND_DOC(val)
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'cadastroFormulario.destinacaoUsoImovel.produtividade.dap' (val) {
      this.update({field: 'destinacaoUsoImovel.produtividade.dap', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.produtividade.drp' (val) {
      this.update({field: 'destinacaoUsoImovel.produtividade.drp', value: val})
    },
    listDocs (val) {
      this.update({field: 'destinacaoUsoImovel.produtividade.documentos', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      const payload = {
        idProcesso: this.idProcesso,
        cadastro: this.montarJson()
      }
      this.salvarCadastroRetificacao(payload)
    },
    'cadastroFormulario.destinacaoUsoImovel.agricultura' (val) {
      this.update({field: 'destinacaoUsoImovel.agricultura', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.pecuaria' (val) {
      this.update({field: 'destinacaoUsoImovel.pecuaria', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.silvicultura' (val) {
      this.update({field: 'destinacaoUsoImovel.silvicultura', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.servidaoAmbiental' (val) {
      this.update({field: 'destinacaoUsoImovel.servidaoAmbiental', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.sistemasAgroflorestais' (val) {
      this.update({field: 'destinacaoUsoImovel.sistemasAgroflorestais', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.outro' (val) {
      this.update({field: 'destinacaoUsoImovel.outro', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.educacao' (val) {
      this.update({field: 'destinacaoUsoImovel.educacao', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.industria' (val) {
      this.update({field: 'destinacaoUsoImovel.industria', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.pesquisa' (val) {
      this.update({field: 'destinacaoUsoImovel.pesquisa', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.mineracao' (val) {
      this.update({field: 'destinacaoUsoImovel.mineracao', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.manejoFlorestal' (val) {
      this.update({field: 'destinacaoUsoImovel.manejoFlorestal', value: val})
    },
    'cadastroFormulario.destinacaoUsoImovel.assistencialHospitalar' (val) {
      this.update({field: 'destinacaoUsoImovel.assistencialHospitalar', value: val})
    },
    listaSemoventes (val) {
      if (val.length > 0) {
        this.update({field: 'destinacaoUsoImovel.semoventes', value: val})
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    listaEdificacoes (val) {
      this.update({field: 'destinacaoUsoImovel.edificacoes', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },

    listaCulturasPermanentes (val) {
      this.update({field: 'destinacaoUsoImovel.culturasPermanentes', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },

    listaCulturasTemporarias (val) {
      this.update({field: 'destinacaoUsoImovel.culturasTemporarias', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },

    listaOutrasAtividades (val) {
      this.update({field: 'destinacaoUsoImovel.outrasAtividades', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    listDocsRemovidos (val) {
      this.update({field: 'destinacaoUsoImovel.produtividade.documentosRemovidos', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'cadastroFormulario.destinacaoUsoImovel.descricaoOutro' (val) {
      this.update({field: 'destinacaoUsoImovel.descricaoOutro', value: val})
    }
  }
}

</script>

<style lang="scss" scoped>

.class-divider {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  margin: 20px 0;
  border-bottom: 2px solid #ebeef5;
}

.labelDiv {
  display: flex;
  padding: 20px;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

.row-buttons {
  display: flex;
}
.row-buttons-sucess {
  display: flex;
  justify-content: end;
}

.labelDivRow {
  display: flex;
  flex-direction: row;
  padding: 20px 0;
}

.erro {
  border: solid 2px red;
}

.col {
  padding: 0 20px 0 0;
}

.inputDiv {
  width: 100%;
}

.selectNacionalidade {
  left: 210px !important;
}

.flex {
  display: flex;
}

.checkbox-group {
  display: flex;
  place-items: center;
  padding: 20px;
}

.erro-message {
  color: red;
  font-size: 15px;
}

.input-select {
  width: 100%;
}

.texto-paragrafo {
  font-weight: bold;
}

.div {
  padding: 20px 0;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/DestinacaoUsoImovel.vue